module.exports = __webpack_public_path__ + "eb1e00b870d7f0784288d76eb3bfc1d5.svg";